export const TYPES = [
  {
    value: 'my network',
    text: 'My Network'
  },
  {
    value: 'office_365',
    text: 'Office365'
  },
  {
    value: 'google_workspace',
    text: 'Google Workspace'
  },
  {
    value: 'aws',
    text: 'AWS'
  },
  {
    value: 'dropbox',
    text: 'Dropbox'
  },
  {
    value: 'box',
    text: 'Box'
  }
]

export const MY_NETWORK_TYPES = [
  {
    value: 'documents',
    text: 'Documents'
  },
  {
    value: 'database',
    text: 'Database'
  }
]

export const DATABASE_TYPES = [
  {
    value: 'mysql',
    text: 'MySQL'
  },
  {
    value: 'mssql',
    text: 'Microsoft SQL Server'
  }
]

export const MY_CLOUD_SERVICES_TYPES = [
  {
    value: 'amazon_web_services',
    text: 'Amazon Web Services'
  },
  {
    value: 'box_net',
    text: 'Box.net'
  },
  {
    value: 'dropbox',
    text: 'Dropbox'
  },
  {
    value: 'google',
    text: 'Google'
  },
  {
    value: 'microsoft_azure',
    text: 'Microsoft Azure'
  }
]

export const MY_OFFICE365_TYPES = [
  {
    value: 'onedrive',
    text: 'One Drive'
  },
  {
    value: 'msemail',
    text: 'Mail'
  },
  {
    value: 'sharepoint',
    text: 'Sharepoint'
  }
]

export const MY_GOOGLE_WORKSPACE_TYPES = [
  {
    value: 'gdrive',
    text: 'Google Drive'
  },
  {
    value: 'gmail',
    text: 'Mail'
  },
  {
    value: 'gdocs',
    text: 'Docs'
  },
  {
    value: 'gsheets',
    text: 'Sheets'
  },
  {
    value: 'gslides',
    text: 'Slides'
  }
]

export const MY_AWS_WORKSPACE_TYPES = [
  {
    value: 's3',
    text: 'S3'
  }
]
export const MY_DROPBOX_TYPES = [
  {
    value: 'dropbox',
    text: 'Dropbox'
  }
]

export const MY_BOX_TYPES = [
  {
    value: 'box',
    text: 'Box'
  }
]
